import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../../../components/util-components/ProtectedRoute";
import React from "react";
import Chat from "./chat";
import ContextManagement from "./context-management";
import WhatsappTemplates from "./settings/whatsapp-templates";

const ChatViews = () => {
  return (
    <Routes>
      <Route
        path={`/`}
        element={
          <ProtectedRoute routeKey={"chat"}>
            <Chat />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/context-management`}
        element={
          <ProtectedRoute routeKey={"context-management"}>
            <ContextManagement />
          </ProtectedRoute>
        }
      />
      <Route path={`/settings/whatsapp-templates`} element={<WhatsappTemplates />} />
    </Routes>
  );
};

export default ChatViews;
